import React, { FC } from 'react'
import GlobalContainer from '../globalContainer'
import { PlatformDiagramOuter } from './style'

//* utils
import { ComponentPlatformDiagram } from '../../../models/components/platformDiagram'
import formatInlineCode from '../../../utils/shortTextFormatting'

//* components
import Typography from '../typography'
import { BottomItems } from './subcomponents/BottomItems'
import { NavigationGroup } from './subcomponents/NavigationGroup'

type Props = {
  data: ComponentPlatformDiagram
}

const PlatformDiagram: FC<Props> = ({ data }) => {
  const platformDiagramData = {
    headline: data.headline || '',
    itemDescription: data.itemDescription || '',
    items: data.items || [],
    megamenu: data.megamenu || {},
  }

  return (
    <GlobalContainer>
      <PlatformDiagramOuter data-cy="platformDiagram">
        <div className="PlatformDiagram__Top-Outer">
          <div className="PlatformDiagram__Heading-Container">
            <span className="PlatformDiagram__Heading-Orange-Line"></span>
            {platformDiagramData.headline && (
              <Typography className="PlatformDiagram__Heading" type="header2">
                {formatInlineCode(platformDiagramData.headline)}
              </Typography>
            )}
          </div>
          <div className="PlatformDiagram__Top-Grid"></div>
        </div>

        <NavigationGroup platformDiagramData={platformDiagramData} />
        <BottomItems platformDiagramData={platformDiagramData} />
      </PlatformDiagramOuter>
    </GlobalContainer>
  )
}

export default PlatformDiagram
